import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { lazyReplyToMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('replyToItem')(function replyToItem(itemId, isReplyAll, instrumentationContexts, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            restrictionToConfirm = {
                ReplyAllAllowed: isReplyAll,
                ReplyAllowed: !isReplyAll,
            };
            if (confirmItemActionAllowed(itemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisItem, isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply))) {
                lazyReplyToMessage.importAndExecute({
                    referenceItemId: itemId,
                    isReplyAll: isReplyAll,
                    useFullCompose: true,
                    actionSource: actionSource,
                    instrumentationContexts: instrumentationContexts,
                });
                mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
            }
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=replyToItem.js.map